function ReportSchedule() {
    "use strict";

    this.__type = 'ReportSchedule:www.veritracks.com';
    this.Id = -1;

    this.ReportId = -1;
    this.AgentId = -1;
    this.OrganizationId = -1;
    this.ReportScheduleName = '';
    this.ReportName = '';
    this.ReportScheduleDateId = -1;
    this.ReportScheduleTimeId = -1;
    this.ReportScheduleTimeSpanId = -1;
    this.EmailFormatId = -1;
    this.TypeDOCFlag = -1;
    this.TypePDFFlag = -1;
    this.TypeXLSFlag = -1;
    this.TypeRTFFlag = -1;
    this.TypeTXTFlag = -1;
    this.TypeCSVFlag = -1;
    this.IsActive = 1;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = ReportSchedule;
}